import { render, staticRenderFns } from "./IconInfo.vue?vue&type=template&id=aeea9b26&"
import script from "./IconInfo.vue?vue&type=script&lang=js&"
export * from "./IconInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports